import FluidSelect from "../../../../../common/components/FluidSelect";
import { getSyntheticEvent } from "../../../../../common/utils/getSyntheticEvent";
import { Operator } from "../../../../../requests_cm/gecoContractsService/types";

export interface CurtailabilityComparatorProps {
	onChange: (event: any) => void;
	comparator: Operator;
}

export function CurtailabilityComparator(
	props: Readonly<CurtailabilityComparatorProps>
) {
	return (
		<FluidSelect
			isLabelStatic
			items={[
				{
					label: "<",
					value: Operator.LOWER_THAN,
				},
				{
					label: "<=",
					value: Operator.LOWER_THAN_OR_EQUAL,
				},
			]}
			label={"Comparator"}
			name={"comparator"}
			// @ts-ignore does not provides an HTMLElement as it should but the value itself
			onChange={(comparator: Operator) =>
				props.onChange(getSyntheticEvent("comparator", comparator))
			}
			value={props.comparator}
		/>
	);
}
